import script from "./baseConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./baseConfig.vue?vue&type=script&setup=true&lang=js"

import "./baseConfig.vue?vue&type=style&index=0&id=6598d1aa&scoped=true&lang=css"

import exportComponent from "D:\\project\\安可控\\Dtsc.Official.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6598d1aa"]])

export default __exports__